export type InsightPostTypeType =
  | typeof InsightPostTypeMemo
  | typeof InsightPostTypeChallenge
  | typeof InsightPostTypeInternalQuestion;

type PostTypeType = {
  id: 1 | 10 | 20;
  name: "メモ" | "チャレンジ" | "社内質問";
  type: "memo" | "challenge" | "internal_question";
};

export const InsightPostTypeMemo = {
  id: 1,
  name: "メモ",
  type: "memo",
} as const;

export const InsightPostTypeChallenge = {
  id: 10,
  name: "チャレンジ",
  type: "challenge",
} as const;

export const InsightPostTypeInternalQuestion = {
  id: 20,
  name: "社内質問",
  type: "internal_question",
} as const;

export const InsightPostTypes = {
  MEMO: InsightPostTypeMemo,
  CHALLENGE: InsightPostTypeChallenge,
  INTERNAL_QUESTION: InsightPostTypeInternalQuestion,
} as const satisfies {
  MEMO: PostTypeType;
  CHALLENGE: PostTypeType;
  INTERNAL_QUESTION: PostTypeType;
};

export const AllInsightPostTypes = [
  InsightPostTypeMemo,
  InsightPostTypeChallenge,
  InsightPostTypeInternalQuestion,
];
